export default {
  "slots": {
    "root": "my-5 gap-4"
  }
}